import React from 'react';
import { Box, Text } from 'rebass/styled-components';
import { useSelector } from 'react-redux';

import { userSelector } from '../../../redux/selectors';
import EmailForm from './EmailForm';
import PasswordForm from './PasswordForm';

const LoginInfo = () => {
  const user = useSelector(userSelector);
  const mapOauthProviders = {
    google_oauth2: 'Google',
    linkedin_oauth2: 'Linkedin',
  };

  return (
    <Box>
      <Box title="Email" mb={3}>
        <EmailForm />
      </Box>
      <Box title="Password" mb={3}>
        {user.hasPassword ? (
          <PasswordForm />
        ) : (
          <Text fontSize="14px">{`You signed up through ${mapOauthProviders[user.oauthProviders[0].provider]}.`}</Text>
        )}
      </Box>
    </Box>
  );
};

export default LoginInfo;
